var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDatetime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 8.00008H6V11.3334H9.33333V8.00008ZM8.66667 0.666748V2.00008H3.33333V0.666748H2V2.00008H1.33333C0.593333 2.00008 0.00666666 2.60008 0.00666666 3.33341L0 12.6667C0 13.4001 0.593333 14.0001 1.33333 14.0001H10.6667C11.4 14.0001 12 13.4001 12 12.6667V3.33341C12 2.60008 11.4 2.00008 10.6667 2.00008H10V0.666748H8.66667ZM10.6667 12.6667H1.33333V5.33341H10.6667V12.6667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatetime);
export default __webpack_public_path__ + "97120/static/media/datetime.d7d3cbc0e4a5618761e28e1b1f41dc1b.svg";
export { ForwardRef as ReactComponent };